import { Observable } from 'rxjs/Rx';
import { EventEmitter, Inject, Injectable, Output } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';

import { REST_BASE_URL, REST_ENDPOINTS } from '../../app.module';

export class StatusMonitorUpdate {
  start: Date;
  end: Date;
  duration: number;
  success: boolean;
  error: HttpErrorResponse;
}

@Injectable()
export class StatusMonitorService {

    static readonly initialDelay = 500;
    static readonly checkIntervall = 5000;

    private readonly checkUrl: string;

    @Output() readonly updated = new EventEmitter();

    constructor(
      @Inject(REST_BASE_URL) restBaseUrl,
      @Inject(REST_ENDPOINTS) restEndpoints,
      private httpClient: HttpClient
    ) {
      this.checkUrl = `${restBaseUrl}${restEndpoints.EMPTY}`;

      const timer = Observable.timer(StatusMonitorService.initialDelay, StatusMonitorService.checkIntervall);
      timer.subscribe(() => {
        const update = new StatusMonitorUpdate();
        update.start = new Date();

        this.httpClient.get(`${this.checkUrl}?${update.start.getTime()}`, { responseType: 'text' }).subscribe(
          () => {
            update.end = new Date();
            update.duration = update.end.getTime() - update.start.getTime();
            update.success = true;

            this.updated.emit(update);
          },
          (err: HttpErrorResponse) => {
            update.end = new Date();
            update.duration = update.end.getTime() - update.start.getTime();
            update.success = false;
            update.error = err;

            this.updated.emit(update);
          }
        );
      });
    }

}



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/services/status-monitor.service.ts